import { BoxDeactivationReason, Subtype } from 'entities/Box';
import { InvoiceFrequencyType, RentState } from 'entities/Invoice';
import { TableFilterType } from 'features/TableFilter';

interface BoxListFilters {
  warehouseId?: string;
  isActive?: boolean;
  hasNotes?: boolean;
  priceFrom?: number;
  priceTo?: number;
  squareFrom?: number;
  squareTo?: number;
  priceRateType?: InvoiceFrequencyType;
  rentState?: RentState;
  floorId?: string;
  deactivationReason?: BoxDeactivationReason;
  subtype?: Subtype;
}

export const transformBoxesListFilters = ({
  selectedWarehouseId,
  hasNotes,
  priceFrom,
  priceTo,
  priceType,
  type,
  squareFrom,
  squareTo,
  floorId,
  availability,
  deactivationReason,
  subtype,
}: TableFilterType): BoxListFilters => {
  return {
    warehouseId: selectedWarehouseId?.value || undefined,
    isActive: availability?.value === undefined ? undefined : availability?.value === 'available',
    hasNotes: hasNotes?.value === undefined ? undefined : hasNotes?.value === 'hasNotes',
    priceFrom: priceFrom?.value || undefined,
    priceTo: priceTo?.value || undefined,
    squareFrom: squareFrom?.value || undefined,
    squareTo: squareTo?.value || undefined,
    priceRateType: priceType?.value || undefined,
    rentState: type?.value || undefined,
    floorId: floorId?.value || undefined,
    deactivationReason: deactivationReason?.value || undefined,
    subtype: subtype?.value || undefined,
  };
};
